import memoize from 'memoizee'

export const getNonStockedRequestHistory = memoize((state, enrollmentId) => {
  const { histories } = state.enrollmentApprovalRequestHistory
  return histories[enrollmentId] || []
})

export const getAncillaryMaterialRequestHistory = memoize((state, id) => {
  const { histories } = state.ancillaryMaterialsApprovalRequestHistory
  return histories[id] || []
})

export const getExceptionTestingRequestHistory = memoize((state, id) => {
  const { histories } = state.exceptionTestingApprovalRequestHistory
  return histories[id] || []
})

export const getOffCycleTestingRequestHistory = memoize((state, id) => {
  const { histories } = state.offCycleTestingApprovalRequestHistory
  return histories[id] || []
})

export const getOrdersAfterDeadlineRequestHistory = memoize((state, id) => {
  const { histories } = state.ordersAfterDeadlineApprovalRequestHistory
  return histories[id] || []
})

export const getReshipmentsRequestHistory = memoize((state, id) => {
  const { histories } = state.reshipmentsApprovalRequestHistory
  return histories[id] || []
})

export const getNonStockedRequestHistoryStatusProps = memoize(state => {
  const { fetching, fetched, error } = state.enrollmentApprovalRequestHistory
  return { fetching, fetched, error }
})

export const getAncillaryMaterialRequestHistoryStatusProps = memoize(state => {
  const { fetching, fetched, error } = state.ancillaryMaterialsApprovalRequestHistory
  return { fetching, fetched, error }
})

export const getExceptionTestingRequestHistoryStatusProps = memoize(state => {
  const { fetching, fetched, error } = state.exceptionTestingApprovalRequestHistory
  return { fetching, fetched, error }
})

export const getOffCycleTestingRequestHistoryStatusProps = memoize(state => {
  const { fetching, fetched, error } = state.offCycleTestingApprovalRequestHistory
  return { fetching, fetched, error }
})

export const getOrdersAfterDeadlineRequestHistoryStatusProps = memoize(state => {
  const { fetching, fetched, error } = state.ordersAfterDeadlineApprovalRequestHistory
  return { fetching, fetched, error }
})

export const getReshipmentsRequestHistoryStatusProps = memoize(state => {
  const { fetching, fetched, error } = state.reshipmentsApprovalRequestHistory
  return { fetching, fetched, error }
})
